import { render, staticRenderFns } from "./versionList.vue?vue&type=template&id=ec429eb4&scoped=true"
import script from "./versionList.vue?vue&type=script&lang=js"
export * from "./versionList.vue?vue&type=script&lang=js"
import style0 from "./versionList.vue?vue&type=style&index=0&id=ec429eb4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec429eb4",
  null
  
)

export default component.exports